export enum PathsInvestors {
  Marketplace = 'marketplace',
  Fund = 'fund',
  MyPortfolio = 'my-portfolio',
  Pool = 'pool',
  ComingSoonPool = 'coming-soon-pool',
  Iframe = 'iframe',
  Kyc = 'kyc',
}
